import message from 'antd/lib/message';

// Global config
message.config({
    duration: 8,
});

export const globalMessage = message;
